import { api } from '../../../redux/setupAxios';

export const getMerchants = async () => {
	try {
		const res = await api.get('/merchants')
		return res.data;
	} catch (error) {
		console.error(error);
	}
}

export const checkMerchant = id =>
	api
		.get(`/merchants/${id}`)
		.then(res => res.data)
		.catch(() => ({ success: false }));

export const editNotifs = async (merchantId, notifs, emails) => {
	try {
		const { data } = await api.put('/merchants/editNotifs', {
			query: {
				merchantId,
				notifs,
				emails
			},
		});
		return data;
	} catch (err) {
		return [];
	}
};